import React from "react";
import { variables as breakpoints } from "@xo-union/tk-ui-breakpoints";
import colors from "@xo-union/tk-ui-colors/lib/variables.css";
var styles = function styles() {
  return "\n.Union__footer-nav-pagelet-placeholder {\n  background-color: var(--tkww-union-footer-nav-background-color, ".concat(colors.varBackgroundDark, ");\n  height: 910px;\n}\n\n@media (").concat(breakpoints.inDesktop, ") {\n  .Union__footer-nav-pagelet-placeholder {\n    height: 639px;\n  }\n}\n");
};
export default (function () {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("style", {
    // eslint-disable-next-line react/no-danger
    dangerouslySetInnerHTML: {
      __html: styles()
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "Union__footer-nav-pagelet-placeholder"
  }));
});